// extracted by mini-css-extract-plugin
export default {"accordionDetails":"Settings_accordionDetails__AC1j0"};